// CompanyDomain_Reducer.js
import { Add_Company_Domain, Get_All_Company_Domain, Get_Error, Update_One_Company_Domain } from '../Types';

const initialState = {
  Companydomain: {
    data: [],           // مصفوفة الشركات
    pagination: {       // بيانات الـ pagination
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false
    }
  },
  loading: true,
  error: null,
};

const CompanyDomain_Reducer = (state = initialState, action) => {
  switch (action.type) {
    case Get_All_Company_Domain:
      // action.payload هو الـ response كامل
      return {
        ...state,
        Companydomain: {
          data: action.payload.data || [],           // مصفوفة الشركات
          pagination: action.payload.pagination || initialState.Companydomain.pagination
        },
        loading: false,
        error: null,
      };

    case Add_Company_Domain:
      return {
        ...state,
        loading: false,
        error: null,
      };


      case Update_One_Company_Domain:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case Get_Error:
      return {
        ...state,
        loading: false,
        error: action.payload,
        Companydomain: {
          ...state.Companydomain,
          data: []
        }
      };
      
    default:
      return state;
  }
};

export default CompanyDomain_Reducer;